import { lazy, type FC, type ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useFragment, graphql } from 'react-relay';

// components
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense.tsx';

// types
import { type PdpSharedAuctionCountdownLazy_item$key as Item } from './__generated__/PdpSharedAuctionCountdownLazy_item.graphql.ts';

// styles
import styles from './PdpSharedAuctionCountdown.scss';

const PdpSharedAuctionCountdown = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedAuctionCountdown" */ './PdpSharedAuctionCountdown.tsx'
        )
);

type Props = {
    item: Item;
};

type RelayVariables = {
    fetchAuction: boolean;
};

type ReduxStoreType = {
    relayVariables: {
        variables: RelayVariables;
    };
};

const Spacer: FC<{ children?: ReactNode }> = ({ children }) => (
    <div className={styles.countdownSpacer}>{children}</div>
);

const itemFragment = graphql`
    fragment PdpSharedAuctionCountdownLazy_item on Item {
        ...PdpSharedAuctionCountdown_item @include(if: $fetchAuction)
    }
`;

export const PdpSharedAuctionCountdownLazy: FC<Props> = ({ item: itemRef }) => {
    const item = useFragment(itemFragment, itemRef);
    const { fetchAuction } = useSelector<ReduxStoreType, RelayVariables>(
        relay => relay?.relayVariables?.variables || {}
    );

    if (!fetchAuction) {
        return <Spacer />;
    }

    return (
        <ClientSuspense fallback={<Spacer />}>
            <PdpSharedAuctionCountdown item={item} />
        </ClientSuspense>
    );
};
